/* ==========================================================================
   td-flavour-tooltip.js
   Flavour-name tooltip for the icons rendered by snippets/cpg-flavour-icons.liquid
   (mega menu, collection cards, Explore products, Bestseller). Loaded by
   layout/theme.liquid only while settings.td_flavour_tooltip is on.

   One shared position: fixed element, not a CSS ::after per icon. The icon
   wrappers clip (.td-mega-menu__swatch is overflow: hidden to crop the artwork
   square) and several strips sit inside overflow-hidden cards, so anything drawn
   inside the wrapper gets cut off. A fixed element escapes every ancestor.

   Delegated from document, so strips rendered or re-rendered after load (the
   mega menu, AJAX-swapped cards) work without re-binding.
   ========================================================================== */
(function () {
  if (window.__tdFlavourTip) return;
  window.__tdFlavourTip = true;

  // Hover only. On touch there is no hover, and a tap on a card icon follows the
  // card link, so a tooltip there would flash for one frame and be noise.
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var GAP = 8;   // px between the icon and the tooltip
  var EDGE = 8;  // px kept clear of the viewport edge
  var ARROW_MIN = 12; // keep the arrow off the rounded corners

  var tip = null;
  var current = null;

  function ensureTip() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'td-flavour-tip';
    // The icon's img alt already carries the same name; a screen reader does not
    // need to hear it twice.
    tip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tip);
    return tip;
  }

  function show(el) {
    var text = el.getAttribute('data-td-tip');
    if (!text) return;
    current = el;
    var t = ensureTip();
    t.textContent = text;
    t.classList.remove('is-below');

    var r = el.getBoundingClientRect();
    var w = t.offsetWidth;
    var h = t.offsetHeight;
    var cx = r.left + r.width / 2;
    var left = Math.min(Math.max(cx - w / 2, EDGE), window.innerWidth - w - EDGE);
    var top = r.top - h - GAP;
    // The mega menu sits right under the header; near the top of the viewport
    // there is no room above, so flip below the icon instead of clipping.
    if (top < EDGE) {
      top = r.bottom + GAP;
      t.classList.add('is-below');
    }
    var arrow = Math.min(Math.max(cx - left, ARROW_MIN), w - ARROW_MIN);

    t.style.left = Math.round(left) + 'px';
    t.style.top = Math.round(top) + 'px';
    t.style.setProperty('--td-tip-arrow', Math.round(arrow) + 'px');
    t.classList.add('is-visible');
  }

  function hide() {
    current = null;
    if (tip) tip.classList.remove('is-visible');
  }

  document.addEventListener('pointerover', function (e) {
    if (!canHover.matches || e.pointerType !== 'mouse') return;
    var el = e.target.closest ? e.target.closest('[data-td-tip]') : null;
    if (el && el !== current) show(el);
  });

  document.addEventListener('pointerout', function (e) {
    if (!current) return;
    var to = e.relatedTarget;
    if (to && current.contains(to)) return;
    if (current.contains(e.target)) hide();
  });

  // The tooltip is fixed to where the icon was; once the page moves it would
  // point at nothing.
  window.addEventListener('scroll', function () { if (current) hide(); }, { capture: true, passive: true });
  window.addEventListener('resize', function () { if (current) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) hide(); });
})();
